import styled from "@emotion/styled";
import {
  IconButton,
  TableFooter,
  TableRow,
  TableCell,
  Typography,
  CircularProgress,
} from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { usersTableColumns } from "./users-helpers";

const TableAction = styled(IconButton)`
  padding: 0.5rem;
  border: solid 1px ${(p) => p.theme.colors.border};
  border-radius: 0.5rem;
  &:hover,
  &:active,
  &:focus {
    border: solid 1px ${(p) => p.theme.colors.border};
  }
`;

const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  margin: 1rem 0;
`;

const PaginationNumber = styled(Typography)`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-width: 2.5rem;
`;

type TableFooterPaginationProps = {
  page: number;
  handleNextPage: () => void;
  handlePreviousPage: () => void;
  isFetchingNextPage: boolean;
  isLastPage: boolean;
};

export const TableFooterPagination = (props: TableFooterPaginationProps) => {
  const {
    handleNextPage,
    handlePreviousPage,
    isFetchingNextPage,
    page,
    isLastPage,
  } = props;

  return (
    <TableFooter>
      <TableRow>
        <TableCell align="center" colSpan={usersTableColumns.length}>
          <PaginationContainer>
            <TableAction onClick={handlePreviousPage} disabled={page === 0}>
              <ChevronLeftIcon />
            </TableAction>
            <PaginationNumber>
              {isFetchingNextPage ? <CircularProgress size={24} /> : page + 1}
            </PaginationNumber>
            <TableAction
              onClick={handleNextPage}
              disabled={isLastPage || isFetchingNextPage}
            >
              <ChevronRightIcon />
            </TableAction>
          </PaginationContainer>
        </TableCell>
      </TableRow>
    </TableFooter>
  );
};
